import {Observable, Subject} from 'rxjs';
import {LookupFeature, LookupFunction} from 'src/app/domain/usecases/features/lookup.feature';
import {LookupViewModel} from 'src/app/domain/presenter/viewmodel/lookup-view.model';
import {VehicleBrand} from 'src/app/domain/core/vehicle-brand.model';
import {AppState} from '../../../shared/utils/AppState';
import {LegalEntity} from '../../core/legal-entity.model';
import {Country} from '../../core/country.model';
import {environment} from '../../../../environments/environment';

export interface LookupControllerDependencies {
  brandString: Observable<string>
  recaptchaToken: Observable<string>
  lookup: LookupFunction;
}

export class LookupController {
  viewModel$ = new Subject<LookupViewModel>()
  viewModel = new LookupViewModel()

  userLookupFeature: LookupFeature

  token: string

  constructor(
    private dependencies: LookupControllerDependencies,
  ) {
    // This is on purpose not injected, so the domain layer is free of angular references.
    this.userLookupFeature = new LookupFeature({
      lookup: dependencies.lookup,
      token$: this.dependencies.recaptchaToken
    });
    this.dependencies.brandString.subscribe(this.setBrand.bind(this))
  }

  // Lifecycle
  async onInit() {
    await this.userLookupFeature.onInit()
    this.pushViewModel();
  }

  // Actions
  async lookup() {
    this.viewModel.inProgress = true
    this.pushViewModel()
    this.viewModel.done = await this.userLookupFeature.run(this.viewModel)
    this.viewModel.inProgress = false
    this.pushViewModel();
  }

  // Helpers
  private setBrand(brandString: string) {
    this.viewModel.brand = new VehicleBrand(brandString)
    AppState.shared.setLegalEntity(LegalEntity.from(this.viewModel.brand, Country.from(environment.country)))
    this.pushViewModel();
  }

  pushViewModel() {
    this.viewModel$.next(this.viewModel);
  }

  setEmail(email: string) {
    this.viewModel.email = email
    this.pushViewModel();
  }
}
